import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ClientHeaderNavigation from '../../components/ui/ClientHeaderNavigation';
import Button from '../../components/ui/Button';
import ConfirmationHeader from './components/ConfirmationHeader';
import AppointmentDetailsCard from './components/AppointmentDetailsCard';
import BookingReferenceCard from './components/BookingReferenceCard';
import ContactInformationCard from './components/ContactInformationCard';
import AppointmentPoliciesCard from './components/AppointmentPoliciesCard';
import CalendarIntegrationCard from './components/CalendarIntegrationCard';
import { useBooking } from '../../components/context/BookingContext';
import { useService } from '../../components/context/ServiceContext';


const BookingConfirmation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [bookingData, setBookingData] = useState(null);
  const { clearServices} = useService();
const {  resetBooking } = useBooking();
    const { companyPath } = useParams();

  useEffect(() => {
    const confirmation = location?.state?.bookingConfirmation;
    if (!confirmation) {
      navigate(`/${companyPath}/date-selection`, { replace: true });
      return;
    }
    setBookingData(confirmation);
  }, [location, navigate]);

  const handleRestartBooking = () => {
    resetBooking();
    navigate(`/${companyPath}/date-selection`, { replace: true });
  };

  const handleBookAnother = () => {
    resetBooking();
    clearServices();
    navigate(`/${companyPath}/`, { replace: true });
  };

  if (!bookingData) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <ClientHeaderNavigation onRestartBooking={handleRestartBooking} />
      
      <main className="pt-24 pb-12 px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <ConfirmationHeader />
          
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8 mt-8">
            <div className="lg:col-span-2 space-y-6">
              <AppointmentDetailsCard bookingData={bookingData} />
              <BookingReferenceCard confirmationNumber={bookingData?.confirmationNumber} />
              <ContactInformationCard />
              <AppointmentPoliciesCard />
            </div>
            
            <div className="lg:col-span-1 space-y-6">
              <CalendarIntegrationCard bookingData={bookingData} />
              
              <div className="bg-gradient-to-br from-primary to-secondary rounded-xl p-6 text-white shadow-lg">
                <h3 className="font-heading font-semibold text-xl mb-3">Book Another Appointment</h3>
                <p className="text-white/90 text-sm font-caption mb-4">
                  Planning ahead? Book your next appointment now and enjoy priority scheduling.
                </p>
                <Button
                  onClick={handleBookAnother}
                  variant="outline"
                  fullWidth
                  iconName="Calendar"
                  className="bg-white text-primary hover:bg-white/90 border-white"
                >
                  Book Another
                </Button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default BookingConfirmation;